// URL helpers for the article generation workers (draft / article / health) and the
// Directus base used by the queue fallback. Extracted from CreateArticle.js.
import { LOCAL_WORKER_ORIGIN } from '../../../api';

export const LOCAL_WORKER_API = LOCAL_WORKER_ORIGIN;
export const REMOTE_WORKER_DRAFT_URLS = [
  'https://api.prosecaptain.com/workers/draft',
  'https://api.prosecaptain.com/workers/api/draft'
];
export const REMOTE_WORKER_ARTICLE_URL = 'https://api.prosecaptain.com/workers/api/article';
export const REMOTE_WORKER_HEALTH_URL = 'https://api.prosecaptain.com/workers/api/health';

export const isLocalhost = () => {
  const host = String(window.location.hostname || '').toLowerCase();
  return host === 'localhost' || host === '127.0.0.1' || host === '::1' || host === '0.0.0.0';
};

export const getDirectusBaseUrl = () => (
  isLocalhost() ? '/directus' : 'https://panel.prosecaptain.com'
);

// Localhost strict mode: hit the local worker API only. Never send local articles to production.
export const getDraftEndpointUrls = () => (
  isLocalhost()
    ? [`${LOCAL_WORKER_API}/api/draft`]
    : REMOTE_WORKER_DRAFT_URLS
);

export const getArticleEndpointUrls = () => (
  isLocalhost()
    ? [`${LOCAL_WORKER_API}/api/article`]
    : [REMOTE_WORKER_ARTICLE_URL]
);

export const getHealthCheckUrl = () => (
  isLocalhost()
    ? `${LOCAL_WORKER_API}/api/health`
    : REMOTE_WORKER_HEALTH_URL
);

/** Human readable (Polish) loader text for a queue_status value. */
export const mapQueueStatusToLoaderText = (queueStatus) => {
  switch (String(queueStatus || '').toLowerCase()) {
    case 'queued':
      return 'Artykul czeka w kolejce workerow';
    case 'processing':
      return 'Worker generuje draft i wykonuje narzedzia';
    case 'draft_ready':
    case 'completed':
      return 'Draft gotowy - finalizujemy zapis';
    case 'error':
    case 'failed':
      return 'Wystapil blad po stronie workera';
    default:
      return 'Pobieramy aktualny status zadania';
  }
};
